import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7074891b"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "position"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "top"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createElementVNode("h1", {
  class: "en"
}, "加入我们"), /*#__PURE__*/_createElementVNode("h2", null, "Join Us")])], -1));
const _hoisted_3 = {
  class: "list-content"
};
const _hoisted_4 = {
  class: "nav"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  class: "more",
  target: "_black",
  href: "https://company.zhaopin.com/CZ849328770.html"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "查看更多职位"), /*#__PURE__*/_createElementVNode("div", {
  class: "right"
})], -1));
const _hoisted_6 = {
  class: "list"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [/*#__PURE__*/_createElementVNode("tr", null, [/*#__PURE__*/_createElementVNode("th", null, "职位名称"), /*#__PURE__*/_createElementVNode("th", null, "职位类别"), /*#__PURE__*/_createElementVNode("th", null, "工作地点"), /*#__PURE__*/_createElementVNode("th", null, "发布时间")])], -1));
const _hoisted_8 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: _normalizeClass(["nav-item", {
      active: $data.nav == 1
    }]),
    onClick: _cache[0] || (_cache[0] = $event => $options.changeTab(1))
  }, "社会招聘", 2), _createElementVNode("div", {
    class: _normalizeClass(["nav-item", {
      active: $data.nav == 2
    }]),
    onClick: _cache[1] || (_cache[1] = $event => $options.changeTab(2))
  }, "校园招聘", 2), _hoisted_5]), _createElementVNode("table", _hoisted_6, [_hoisted_7, _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, item => {
    return _openBlock(), _createElementBlock("tr", {
      class: "list-item",
      key: item.unid,
      onClick: $event => $options.goDetail(item)
    }, [_createElementVNode("td", null, _toDisplayString(item.positionName), 1), _createElementVNode("td", null, _toDisplayString(item.position), 1), _createElementVNode("td", null, _toDisplayString(item.address), 1), _createElementVNode("td", null, _toDisplayString(item.publishTime.slice(0, 10)), 1)], 8, _hoisted_8);
  }), 128))])])])]);
}